function asyncInputEvent(asyncHandler, syncHandler) {
  var debounceTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 400;
  var t;
  return function (e) {
    e.persist();
    syncHandler && syncHandler(e);
    clearTimeout(t);
    t = window.setTimeout(function () {
      asyncHandler(e);
    }, debounceTime);
  };
}

;
export { asyncInputEvent };